import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Link } from '@bd/bdcore-named-routes';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { typography, colors } from '../../styles';
import Carousel from '../../components/CarouselHome';

const styles = css`

  .HeroImage_Headline {
    text-align: center;
    color: white;
    padding:20px;
    font:900 30px/1.3 ${typography.SansSerif};
    text-transform: uppercase;
    @media (min-width: 992px) {
      padding:40px;
      font:900 64px/1.2 ${typography.SansSerif};
    }
  }
  .SlideshowMedia {
    position:absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
    display:flex;
    flex-flow:column wrap;
    justify-content: center;
    background-position: center;
    background-size: cover;
  }

  .heroBanner_label {
    position: absolute;
    bottom:0;
    left:0;
    background:white;
    padding:15px;
    font:700 18px/1.1 ${typography.SansSerif};
    text-transform: uppercase;
    @media (min-width: 991px) {
      font:700 20px/1.1 ${typography.SansSerif};
      padding:20px;
    }

    .heroBanner_label-colorOne {
      color:${colors.color1};
    }
    .heroBanner_label-colorTwo {
      color:${colors.color2};
    }
  }
`;

function HeroImage({ page }) {
  return (
    <div
      className={styles}
    >
      <Carousel
        autoplay
        interval={5000}
        items={get(page, 'hero_banner', []).map(slide => ({
          element: (
            <Link name="communities" className="SlideshowMedia" style={{ backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.25) 0%,rgba(0,0,0,0.25) 100%), url(${buildThumbnailUrl(get(slide, 'image.contentUrl'), { width: 2000, height: 1500 })})` }}>
              {/* <div className="SlideshowContent">
                <h2 dangerouslySetInnerHTML={SanitizeHtml(get(slide, 'headline'))} />
                <div className="SlideshowContent_description">{get(slide, 'description')}</div>
              </div> */}
              <div className="container">
                <h2 className="HeroImage_Headline">{slide.headline}</h2>
              </div>
              <div className="heroBanner_label"><span className="heroBanner_label-colorOne">{slide.label_color_one}</span> <span className="heroBanner_label-colorTwo">{slide.label_color_two}</span></div>
            </Link>
          ),
        }))}
        mainImageProps={{
          width: 2000,
          height: 2000 * 0.5625,
          exact: true,
        }}
      />
    </div>
  );
}

HeroImage.propTypes = {
  page: PropTypes.object.isRequired,
};

export default HeroImage;



// WEBPACK FOOTER //
// ./src/pages/IndexPage/HeroImage.js